import React from "react";
import { User, Quote } from "lucide-react";
import { PageHero, Section } from "./_shared";
import { useMitmcvc } from "./MitmcvcLayout";

export default function Leadership() {
  const data = useMitmcvc();
  const list = data?.leadership || [];

  return (
    <div data-testid="mitmcvc-leadership">
      <PageHero
        eyebrow="नेतृत्वाचा संदेश"
        title="मार्गदर्शक विचार"
        sub="ट्रस्टच्या पदाधिकाऱ्यांचा व प्राचार्यांचा मार्गदर्शक संदेश — शिक्षण, गुणवत्ता व सामाजिक बांधिलकीविषयी."
      />
      <Section>
        {list.length === 0 ? (
          <div className="bg-white border-2 border-dashed border-amber-100 p-16 text-center" data-testid="mitmcvc-leadership-empty">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-[#F59E0B]/15 text-[#B45309]">
              <Quote size={28} />
            </div>
            <div className="font-serif text-xl text-[#14532D] mt-5">संदेश लवकरच प्रकाशित होतील</div>
            <p className="text-sm text-slate-500 mt-2 max-w-md mx-auto">संस्थेच्या प्रशासकीय कक्षामार्फत संदेश प्रकाशित झाल्यावर ते इथे उपलब्ध होतील.</p>
          </div>
        ) : (
          <div className="space-y-10">
            {list.map((m, i) => (
              <article
                key={m.id}
                data-testid={`mitmcvc-leader-${(m.designation || "member").replace(/\s+/g, "-")}`}
                className={`bg-white border border-amber-100 overflow-hidden flex flex-col md:flex-row shadow-sm ${
                  i % 2 === 1 ? "md:flex-row-reverse" : ""
                }`}
              >
                <div className="md:w-1/3 bg-gradient-to-br from-[#14532D] via-[#166534] to-[#052E16] flex items-center justify-center p-8 relative">
                  <div className="absolute top-4 left-4 text-[#F59E0B]/60"><Quote size={40} strokeWidth={1.3} /></div>
                  <div className="w-44 h-44 rounded-full overflow-hidden border-4 border-[#F59E0B] shadow-lg bg-white">
                    {m.photo_url ? (
                      <img src={m.photo_url} alt={m.name} className="w-full h-full object-cover" />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center text-[#14532D]"><User size={56} strokeWidth={1.4} /></div>
                    )}
                  </div>
                </div>
                <div className="flex-1 p-8">
                  <div className="text-[10px] tracking-[0.3em] uppercase text-[#B45309] font-bold">{m.designation}</div>
                  <h2 className="font-serif text-2xl md:text-3xl text-[#14532D] mt-1 leading-tight">{m.name || "—"}</h2>
                  {m.message_html && (
                    <div className="prose prose-slate max-w-none mt-4 text-slate-700" dangerouslySetInnerHTML={{ __html: m.message_html }} />
                  )}
                </div>
              </article>
            ))}
          </div>
        )}
      </Section>
    </div>
  );
}
